import { ScaleOut } from 'vue-loading-spinner'

export default {
  name: 'Loading',
  components: {
    ScaleOut
  },
  props: {
    color: String,
    size: String,
    customClass: String,

    zIndex: {
      type: String,
      default: () => '2',
    },
    description: {
      type: String,
      default: () => ''
    },
  },
  computed: {
    iconColor () {
      return this.color || '#03a0f0'
    },
    iconSize () {
      return this.size || '40px'
    },
    style () {
      return 'zIndex: ' + this.zIndex
    }
  }
}